import { getCookie } from '../shared/utils/cookie';
const DISCOUNT_NOTIFICATION_SHOW_DELAY = 500;
const DISCOUNT_NOTIFICATION_HIDE_DELAY = 4000;

export const showDiscountNotification = () => {
  const discountCodeCookie = getCookie('discount_code');
  if (!discountCodeCookie) {
    return;
  }

  const notificationKey = `discountNotificationShown_${discountCodeCookie}`;
  if (sessionStorage.getItem(notificationKey)) {
    return;
  }

  const notification = document.querySelector<HTMLDivElement>(
    '#js-discount-notification'
  );

  if (!notification) {
    console.warn('Discount notification element not found');
    return;
  }

  sessionStorage.setItem(notificationKey, 'true');

  setTimeout((): void => {
    notification.classList.remove(
      'opacity-0',
      '-translate-y-20',
      'pointer-events-none'
    );
    notification.classList.add('opacity-100', 'translate-y-4');
  }, DISCOUNT_NOTIFICATION_SHOW_DELAY);

  setTimeout((): void => {
    notification.classList.remove('opacity-100', 'translate-y-4');
    notification.classList.add(
      'opacity-0',
      '-translate-y-20',
      'pointer-events-none'
    );
  }, DISCOUNT_NOTIFICATION_SHOW_DELAY + DISCOUNT_NOTIFICATION_HIDE_DELAY);
};
